import api from "./axios";

class ServiceBoleto {
  async getIframe() {
    const { data } = await api.get(`/boleto/get-iframe-url`);

    return data;
  }

  async generateBoleto(billId) {
    const { data } = await api.get(`/boleto/${billId}`);

    return data;
  }
}

export default new ServiceBoleto()